export const loadImage = async productName => {
  const {
    default: image
  } = await import(`@eti/assets/images/products/${productName}_800.jpg`);
  return image;
};
//# sourceMappingURL=header.js.map